import * as React from 'react';

import { useSlug } from '../hooks/useSlug';
import { GlobalProps } from '../types';
import { classes } from '../utils';

import styles from './styles.module.css';

export type Props = GlobalProps & {
  children?: React.ReactNode;
  rounded?: boolean;
  variant?: 'default' | 'outline' | 'lined' | 'shadow' | 'solid' | 'rounded';
  borderColor?: React.CSSProperties['borderColor'];
  backgroundColor?: React.CSSProperties['backgroundColor'];
};

export const Container = React.forwardRef<HTMLDivElement, Props>(
  function ContainerComponent(props: Props, ref) {
    const {
      children,
      variant = 'default',
      rounded = false,
      name = 'container',
      borderColor,
      backgroundColor,
    } = props;

    // local background
    let bg = backgroundColor;

    // if user did not define the background
    if (!bg) {
      // and the variant is outlined
      if (variant === 'outline') {
        // use transparent
        bg = 'transparent';
      } else {
        bg = 'var(--color-gray-200)';
      }
    }

    const slugName = useSlug(name);
    const roundedCorners = rounded && variant !== 'lined';
    const cx = classes(
      [
        styles.base,
        styles[variant],
        {
          [styles.roundedCorners]: roundedCorners,
        },
      ],
      props
    );

    const style = {
      '--border-color': borderColor,
      '--background-color': bg,
    } as React.CSSProperties;

    return (
      <section
        className={cx}
        ref={ref}
        data-component={slugName}
        style={style}
        data-rounded={roundedCorners}
      >
        <span className={styles.inner}>{children}</span>
      </section>
    );
  }
);
